import _ from 'lodash';

export const renameFile = (file: File, name: string) => {
  const blob = file.slice(0, file.size, file.type);
  return new File([blob], `${name}.${_.last(file.name.split('.'))}`, { type: file.type });
};
